export const roleAbbreviation = (role: string) => {
  const abbreviation: any = {
    doctor: 'MED',
    nurse: 'IDE',
    helper: 'AS',
    secretary: 'AMA',
    manager: 'ADM',
    technician: 'TECH',
    technologist: 'TECH',
  }
  return abbreviation?.[role] || ''
}
